/** localStorage key prefix of SignView's per-document draft backup (holds signer names and emails). */
export const SIGN_DRAFT_KEY_PREFIX = 'evrysign_draft_';

/**
 * Remove the auth tokens and any account-scoped data persisted in localStorage.
 * Used on logout and when the server rejects the refresh token, so the next
 * account in the same browser never sees the previous one's drafts.
 */
export function clearPersistedSession(): void {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  Object.keys(localStorage)
    .filter((key) => key.startsWith(SIGN_DRAFT_KEY_PREFIX))
    .forEach((key) => localStorage.removeItem(key));
}
